import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-contributors',
  templateUrl: './contributors.component.html',
  styleUrls: ['../../app.component.css', './contributors.component.css']
})

export class ContributorsComponent {

  @Input() contributors;
  
}



// WEBPACK FOOTER //
// ./src/app/shared/contributors/contributors.component.ts